import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../components/layout/layout"
import Button from "../../components/button/button"
import PrimaryBanner from "../../components/banner/primaryBanner"
import TeamsPlusCard from "../../components/card/TeamsPlusCard"
import LXPCard from "../../components/card/LXPCard"

import "../../styles/_solution.scss"

import greenVector from "../../images/green-vector.svg"
import learnPlusLogo from "../../images/learnplus-logo.svg"
import LearnPlusManager from "../../images/learnplus-manager.png"
import flagIcon from "../../images/icon/flag.svg"
import lockIcon from "../../images/icon/lock.svg"
import gearIcon from "../../images/icon/gear.svg"
import arrowDownGrey from "../../images/icon/arrow-down-grey.svg"
import learnplus3 from "../../images/learnplus3.svg"
import quoteIcon from "../../images/icon/quote.svg"
import newWindowIcon from "../../images/icon/new-window.svg"
import newWindowDarkIcon from "../../images/icon/new-window-dark.svg"

const Brief: React.FC = () => {
  return (
    <div className="brief-container layout-container">
      <div className="brief-left">
        <h1>
          <span>Accredited </span>
          <span>qualifications</span>
        </h1>
        <div className="solution-with-container">
          <span className="solution-with-label">with</span>
          <img src={learnPlusLogo} alt="learn plus logo" />
        </div>
        <p className="p-lg" style={{ marginBottom: "35px" }}>
          Flexible pathways to national qualifications with LearnPlus, our
          accredited Category One NZQA private training provider.
        </p>
        <a
          href="https://learnplus.ac.nz"
          style={{ textDecoration: "none" }}
          target="_blank"
          rel="noreferrer"
        >
          <Button isResponsive={true}>
            Learn more at learnplus.ac.nz
            <img
              alt="go to learn plus"
              src={newWindowIcon}
              style={{ width: "20px", marginLeft: "15px" }}
            />
          </Button>
        </a>
      </div>
      <div className="brief-right">
        <div className="brief-right-background learnplus-right"></div>
        <div className="brief-right-image learnplus-right"></div>
      </div>
    </div>
  )
}

const IconSection: React.FC = () => {
  return (
    <div className="solution-icons-section">
      <div className="icon-group layout-container">
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={flagIcon} alt="accredited qualifications" />
          </div>
          <div className="icon-content">
            <p className="p-re">Accredited</p>
            <p className="p-re">qualifications</p>
          </div>
        </div>
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={gearIcon} alt="Flexible Learning" />
          </div>
          <div className="icon-content">
            <p className="p-re">Flexible</p>
            <p className="p-re">learning</p>
          </div>
        </div>
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={lockIcon} alt="Highly Trusted" />
          </div>
          <div className="icon-content">
            <p className="p-re">Highly</p>
            <p className="p-re">trusted</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const CardSection: React.FC = () => {
  const PathwayCard: React.FC = () => {
    return (
      <div className="solution-card-wrapper">
        <div className="pathway-card-container">
          <div className="pathway-card-top"></div>
          <div className="pathway-card-bottom">
            <div className="pathway-card-heading">
              New Zealand Certificate in Business (First Line Management) (Level
              4)
            </div>
            <div className="grey-stick"></div>
            <div className="grey-stick"></div>
            <div className="pathway-enrol-container">
              <div className="pathway-enrol-button">Enrol</div>
            </div>
          </div>
        </div>
        <img
          src={greenVector}
          className="pathway-card-vector"
          alt="Background blob"
        />
        <div className="pathway-card-shadow"></div>
      </div>
    )
  }

  const LearningCard: React.FC = () => {
    return (
      <div className="solution-card-wrapper learning-card-wrapper">
        <div className="learning-card-container">
          <div className="learning-card-top">Training due date</div>
          <div className="learning-card-bottom">
            <div className="learning-card-line">
              Due&nbsp;
              <span className="learning-card-period">
                1 month&nbsp;
                <img
                  src={arrowDownGrey}
                  className={"learning-card-dropdown"}
                  alt="Due date dropdown"
                />
              </span>
              &nbsp;from date assigned
            </div>
            <div className="learning-card-line">
              Recurs every&nbsp;
              <span className="learning-card-period">
                12 months&nbsp;
                <img
                  src={arrowDownGrey}
                  className={"learning-card-dropdown"}
                  alt="Recurrence dropdown arrow"
                />
              </span>
            </div>
            <div className="learning-card-button">
              <div className="learning-card-button-stick"></div>
            </div>
          </div>
        </div>
        <img
          src={greenVector}
          className="learning-card-vector"
          alt="Background blob"
        />
        <div className="learning-card-shadow"></div>
      </div>
    )
  }

  const ReportCard: React.FC = () => {
    return (
      <div className="report-card-group">
        <img src={learnplus3} alt="learn plus" />
      </div>
    )
  }

  return (
    <div className="solution-group-wrapper">
      <div className="layout-container">
        <div className="solution-wrapper">
          <div className="solution-content">
            <h3 style={{ marginBottom: "10px" }}>
              Accredited professional pathways
            </h3>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Accredited Category One NZQA private training provider with
              flexible learning pathways
            </p>
          </div>
          <PathwayCard></PathwayCard>
        </div>
        <div className="solution-wrapper">
          <LearningCard></LearningCard>
          <div className="learning-content">
            <h3 style={{ marginBottom: "10px" }}>Flexible learning</h3>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Learn virtually anywhere with a learning experience that is
              personalised to your learning pace and style
            </p>
          </div>
        </div>
        <div className="solution-wrapper solution-report-wrapper">
          <div className="solution-content">
            <h3 style={{ marginBottom: "10px" }}>Highly trusted</h3>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Learning is delivered by our team of specialist professionals on a
              highly secure, privacy-focused platform
            </p>
          </div>
          <ReportCard></ReportCard>
        </div>
      </div>
    </div>
  )
}

const ReviewSection: React.FC = () => {
  const ReviewCard: React.FC = () => {
    return (
      <div className="review-card-container">
        <div className="review-card-quote">
          <img src={quoteIcon} alt="quote icon" />
        </div>
        <p className="p-lg">
          We are an innovative training provider offering learning virtually
          anywhere.
        </p>
        <div className="review-owner-wrapper">
          <div className="review-owner-container">
            <img
              src={LearnPlusManager}
              className="review-owner-image"
              alt="Learn plus manager"
            />
            <div>
              <div style={{ fontWeight: "700" }}>Geordie Wilson</div>
              <div>General Manager</div>
            </div>
          </div>
          <img src={learnPlusLogo} alt="LearnPlus Logo" />
        </div>
      </div>
    )
  }

  return (
    <PrimaryBanner>
      <div className="layout-container">
        <div className="review-section-container">
          <ReviewCard></ReviewCard>
          <h2 className="review-heading">Choose the better way of learning</h2>
          <a
            href="https://learnplus.ac.nz"
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noreferrer"
          >
            <Button isSecondary={true} isSmall={true}>
              Learn more at learnplus.ac.nz
              <img
                alt="go to learn plus"
                src={newWindowDarkIcon}
                style={{ width: "20px", marginLeft: "15px" }}
              />
            </Button>
          </a>
        </div>
      </div>
    </PrimaryBanner>
  )
}

const OtherSolutionSection: React.FC = () => {
  return (
    <div className="layout-container other-solution-section-container">
      <h2>Explore other solutions</h2>
      <div className="other-solution-card-group">
        <TeamsPlusCard className="other-solution-card"></TeamsPlusCard>
        <LXPCard className="other-solution-card"></LXPCard>
      </div>
    </div>
  )
}

const LearnPlus: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <title>Dacreed | Solution LearnPlus</title>
        <meta
          name="description"
          content="LearnPlus - Flexible Learning Pathways to Accredited Qualifications"
        />
      </Helmet>
      <Brief></Brief>
      <IconSection></IconSection>
      <CardSection></CardSection>
      <ReviewSection></ReviewSection>
      <OtherSolutionSection></OtherSolutionSection>
    </Layout>
  )
}

export default LearnPlus
